import React from "react";
import { Box, Container } from "@mui/material"

const PublicTemplate = ({ children }) => {
    return (
		<Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', backgroundColor: (theme) => theme.custom.pageBg }}>
			<Container maxWidth="sm">
				<Box component="span" m={5} textAlign="center">
					{children}
				</Box>
			</Container>
		</Box>
    )
}

export default PublicTemplate;